<template>
  <div class="container">
    <img class="wow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/guitar-wow.png"/>
    <img class="top-title" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/rule/rule-banner.png"/>
    <div class="back-btn" @click="toPage(0)">
      <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/1.png"/>
      <span>返回首页</span>
    </div>
    <div class="rule-content">
      <p>
音乐窝六周年拼图赢大奖活动规则<br/>
<br/>
一 活动时间<br/>
8月17日00:00 - 8月31日24:00<br/>
<br/>
二 活动说明<br/>
1 玩法：点击页面中“开始挑战”，在60秒内将打乱的图片分块拼回原图即挑战成功，超时未完成即挑战失败；<br/>
2 挑战及抽奖机会<br/>
<span class="dot"></span>每天首次挑战成功可获得1次抽奖机会；<br/>
<span class="dot"></span>每人每天有3次挑战机会，通过分享活动可增加挑战机会，每天最多可增加5次挑战机会。<br/>
<br/>
三 奖品内容<br/>
1 活动期间用户可通过抽奖获得价值30元的礼品券、200元现金抵扣券等奖励；<br/>
2 奖品兑换<br/>
<span class="dot"></span>已抽中的奖品，可在活动首页-我的奖品中查看，奖品需先领取后凭兑换码到活动适用门店兑换；<br/>
<span class="dot"></span>礼品券可兑换价值30元的实体奖品【具体奖品内容以各门店实际提供为准，可兑换前致电门店咨询】，一张礼品券仅限兑换1次；<br/>
<span class="dot"></span>200元现金抵扣券，购买课包订单实付金额满2000元可使用，每个订单限使用1张，用券订单发生退款，券均不退回；<br/>
3 领取及兑换时间：礼品券/现金抵扣券自中奖之日起7天内需领取，领取之日起30天内到店兑换使用，预期未领取/未兑换视为放弃奖品。<br/>
<br/>
四 其他<br/>
1 活动期间，如遇不可抗力情况，包括但不限于黑客攻击、系统故障、活动受政府机关指令需停止举办或调整本活动的，音乐窝可调整/暂停或提前终止活动；<br/>
2 活动期间，用户不得使用形式破坏活动规则、违背活动公平原则参加本次活动（如虚假分享、倒买倒卖、虚假交易等），否则音乐窝有权取消用户参与活动资格，取消已经领取或使用的奖品。<br/>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props:['pageStep'],
  methods:{
    toPage(i){
      this.$emit('update:pageStep',i);
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  height: 100vh;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/bg.png);
  background-position: center top;
  background-size: 100% 100%;
  position: relative;
  text-align: center;
  overflow: hidden;
}
.back-btn{
  position: fixed;
  top:14px;
  right:10px;
  display: flex;
  align-items: center;
  z-index: 100;
  img{
    width: 40px;
    height: 40px;
  }
  span{
    font-size: 16px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    margin-left: 8px;
  }
}
.wow{
  position: absolute;
  top:10px;
  width: 123px;
  height: auto;
  z-index: 100;
  left:0;
  right:0;
  margin: 0 auto;
}
.top-title{
  position: absolute;
  width: 304px;
  height: auto;
  z-index: 101;
  top: 98px;
  left:0;
  right:0;
  margin: 0 auto;
}
.rule-content{
  position: absolute;
  top: 148px;
  left: 18px;
  right:18px;
  bottom:24px;
  background: rgba(0, 78, 44, 0.55);
  border: 2px solid rgba(255, 255, 255, 1);
  padding:49px 35px 12px 35px;
  border-radius: 30px;
  overflow: hidden auto;
  text-align: left;
  color:#fff;
  font-size: 14px;
  line-height: 26px;
  .dot{
    width: 6px;
    height: 6px;
    background-color: #fff;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 6px;
  }
}
</style>